import LanguageToggle from './LanguageToggle';
import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { asset, Arrow } from './UI';
export default function Navbar() {
  const {
    t
  } = useTranslation();
  const links = [['/', t("home")], ['/aboutus', t("about_us")], ['/catalogue', t("products")], ['/expo', 'Expo'], ['/awards', t("awards")], ['/partner', t("partnerships")], ['/contactus', t("contact")]];
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const toggle = useRef(null);
  useEffect(() => {
    setOpen(false);
    if (location.hash) {
      requestAnimationFrame(() => document.getElementById(location.hash.slice(1))?.scrollIntoView());
    } else window.scrollTo(0, 0);
  }, [location]);
  return <><a href="#main" className="skip-link">{t("skip_to_content")}</a><div className="announcement">{t("the_flavours_of_minangkabau_wherever_life_takes_you")}</div><header className="site-header"><div className="nav-wrap wrap"><Link to="/" aria-label={t("nak_taraso_home")} className="brand"><img src={asset('logo.png')} alt="Nak Taraso" width="160" height="66" /></Link><LanguageToggle /><button ref={toggle} className="menu-toggle" aria-expanded={open} aria-controls="navigation" onClick={() => setOpen(!open)}>{open ? t("close_detail") : 'Menu ☰'}</button><nav aria-label={t("main_navigation")} id="navigation" className={open ? 'navigation is-open' : 'navigation'} onKeyDown={e => {
          if (e.key === 'Escape') {
            setOpen(false);
            toggle.current?.focus();
          }
        }}>{links.map(([to, label]) => <NavLink key={to} to={to} end={to === '/'}>{label}</NavLink>)}</nav><Link to="/catalogue" className="nav-shop">{t("shop")} <Arrow /></Link></div></header></>;
}
